export default __webpack_public_path__ + "static/media/Three.badc1353.png";